import * as React from 'react';

import * as s from './Label.css';

interface ILabel {
  label: string;
  after?: React.ReactNode;
  children?: React.ReactNode;
  required?: boolean;
  strong?: boolean;
}

/**
 * Кастомный лэйбл для филдов
 */
export const Label = ({ label, required, children, after, strong }: ILabel) => (
  <label>
    <div className={s['wrapper']}>
      <div className={`${s['label']} ${required ? s['required'] : ''} ${strong ? s['strong'] : ''}`}>{label}</div>
      {after && <div className={s['after']}>{after}</div>}
    </div>

    {children}
  </label>
);
